module.exports = __webpack_public_path__ + "static/media/HDFCBANK_F1.612cb457.txt";